module.exports = __webpack_public_path__ + "static/media/HomeOutcomeLearnCreator.885386c0.jpg";